import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  .link {
    cursor: pointer;
  }
  .circular-image {
    border-radius: 50%;
    object-fit: cover;
  }
`;
